<div class="main-wrapper">

  <!-- partial:sidebar -->
  <app-sidebar />
  <!-- partial -->
  <app-right-sidebar />

  <div class="page-wrapper">

    <!-- partial:navbar -->
    <app-navbar></app-navbar>
    <!-- partial -->

    <mat-sidenav-container class="sidenav-wrapper">
      <mat-sidenav-content>
        <div class="page-content container-fluid">
          <app-navigationlink></app-navigationlink>
          <div [ngClass]="{ textx: isMargin }">
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>

    </mat-sidenav-container>

    <!-- partial:footer -->
    <app-footer></app-footer>
    <!-- partial -->

  </div>

  <!-- Global Chatbot - visible only after login -->
  <!-- <ng-container *ngIf="showChatboxAgent">
    <app-chatbox-smartdocs class="base-chatbox-agent" />
  </ng-container> -->

</div>
